var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_vm._t("main-header"),_c('router-view'),_vm._t("main-footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }